import { type TFunction } from "i18next";

import { AppRoute } from "@/types/routes";

export interface NavItem {
  key: string;
  url: string;
  label: string;
}

export interface NavItemGates {
  isTaxRequired: boolean;
}

export const getNavItems = (
  t: TFunction,
  { isTaxRequired }: NavItemGates
): NavItem[] => {
  const items: NavItem[] = [
    { key: "home", url: AppRoute.HOME, label: t("tabBar_home") },
    { key: "payments", url: AppRoute.PAYMENTS, label: t("tabBar_payments") },
    { key: "trial", url: AppRoute.TRIAL, label: t("visits_trialTitle") },
    { key: "visits", url: AppRoute.VISITS, label: t("visits_title") },
  ];

  if (isTaxRequired) {
    items.push({ key: "tax", url: AppRoute.TAX, label: t("tax") });
  }

  return items;
};

export const isNavItemActive = (item: NavItem, pathname: string): boolean => {
  if (item.key === "home") {
    return pathname === "/" || pathname === String(AppRoute.HOME);
  }
  if (item.key === "payments") {
    return (
      pathname.startsWith(AppRoute.PAYMENTS) ||
      pathname.startsWith("/payment/") ||
      pathname.startsWith("/stipend/") ||
      pathname.startsWith("/micropayment/") ||
      pathname.startsWith("/receipt/") ||
      pathname.startsWith("/mileage/")
    );
  }
  return pathname === item.url || pathname.startsWith(`${item.url}/`);
};
